import React, { useEffect, useState } from "react";
import { db } from "../firebase/config";
import {
  collection,
  getDocs,
  doc,
  updateDoc,
  arrayUnion,
  arrayRemove,
} from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { FaThumbsUp, FaThumbsDown, FaArrowLeft } from "react-icons/fa";
import Navbar from "./Navbar";
import "../styles/home.css";

const Home = () => {
  const [posts, setPosts] = useState([]);
  const [activePost, setActivePost] = useState(null);

  const auth = getAuth();
  const username = auth.currentUser?.displayName || "Guest";

  useEffect(() => {
    const loadPosts = async () => {
      const snap = await getDocs(collection(db, "posts"));
      setPosts(
        snap.docs.map((d) => ({
          id: d.id,
          ...d.data(),
          likes: d.data().likes || [],
          dislikes: d.data().dislikes || [],
        }))
      );
    };
    loadPosts();
  }, []);

  const handleLike = async (id) => {
    const post = posts.find((p) => p.id === id);
    const ref = doc(db, "posts", id);

    const liked = post.likes.includes(username);
    const disliked = post.dislikes.includes(username);

    await updateDoc(ref, {
      likes: liked ? arrayRemove(username) : arrayUnion(username),
      dislikes: disliked ? arrayRemove(username) : arrayRemove(username),
    });

    setPosts((prev) =>
      prev.map((p) =>
        p.id === id
          ? {
              ...p,
              likes: liked
                ? p.likes.filter((u) => u !== username)
                : [...p.likes, username],
              dislikes: p.dislikes.filter((u) => u !== username),
            }
          : p
      )
    );

    if (activePost?.id === id) {
      setActivePost((prev) => ({
        ...prev,
        likes: liked
          ? prev.likes.filter((u) => u !== username)
          : [...prev.likes, username],
        dislikes: prev.dislikes.filter((u) => u !== username),
      }));
    }
  };

  const handleDislike = async (id) => {
    const post = posts.find((p) => p.id === id);
    const ref = doc(db, "posts", id);

    const disliked = post.dislikes.includes(username);
    const liked = post.likes.includes(username);

    await updateDoc(ref, {
      dislikes: disliked ? arrayRemove(username) : arrayUnion(username),
      likes: liked ? arrayRemove(username) : arrayRemove(username),
    });

    setPosts((prev) =>
      prev.map((p) =>
        p.id === id
          ? {
              ...p,
              dislikes: disliked
                ? p.dislikes.filter((u) => u !== username)
                : [...p.dislikes, username],
              likes: p.likes.filter((u) => u !== username),
            }
          : p
      )
    );

    if (activePost?.id === id) {
      setActivePost((prev) => ({
        ...prev,
        dislikes: disliked
          ? prev.dislikes.filter((u) => u !== username)
          : [...prev.dislikes, username],
        likes: prev.likes.filter((u) => u !== username),
      }));
    }
  };

  return (
    <>
      <Navbar />

      <div className="home-wrapper">
        {/* 🟦 HOME – CARDS */}
        {!activePost && (
          <div className="cards-grid">
            {posts.map((post) => (
              <div
                key={post.id}
                className="post-card"
                onClick={() => setActivePost(post)}
              >
                {/* IMAGE */}
                <img
                  src={post.imageUrl}
                  alt={post.title}
                  className="card-image"
                />

                {/* TITLE */}
                <h3>{post.title}</h3>

                {/* LIKES */}
                <div className="card-footer">
                  <button
                    className={post.likes.includes(username) ? "like active" : "like"}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleLike(post.id);
                    }}
                  >
                    <FaThumbsUp /> {post.likes.length}
                  </button>

                  <button
                    className={post.dislikes.includes(username) ? "dislike active" : "dislike"}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDislike(post.id);
                    }}
                  >
                    <FaThumbsDown /> {post.dislikes.length}
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* 🟦 READER VIEW */}
        {activePost && (
          <div className="reader-view">
            <button className="back-btn" onClick={() => setActivePost(null)}>
              <FaArrowLeft /> Back
            </button>

            <h1>{activePost.title}</h1>

            <div
              className="reader-content"
              dangerouslySetInnerHTML={{ __html: activePost.content }}
            />

            <div className="reader-actions">
              <button
                className={activePost.likes.includes(username) ? "like active" : "like"}
                onClick={() => handleLike(activePost.id)}
              >
                <FaThumbsUp /> {activePost.likes.length}
              </button>

              <button
                className={activePost.dislikes.includes(username) ? "dislike active" : "dislike"}
                onClick={() => handleDislike(activePost.id)}
              >
                <FaThumbsDown /> {activePost.dislikes.length}
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Home;
